import { map } from "rxjs/operators";
import { AddressBookWalletHostModel } from "@modules/main/components/address-book-wallet/model/address-book-wallet.model";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BpSelectOption } from "@modules/core/components/bp-select/bp-select.component";
import { AddressBookWalletService } from "@modules/main/components/address-book-wallet/services/address-book-wallet.service";

@Injectable({ providedIn: "root" })
export class AddressBookHoldModalFacade {
	constructor(private readonly walletService: AddressBookWalletService) {}

	public getWalletHostsOptions(): Observable<BpSelectOption[]> {
		return this.walletService.getWalletHosts().pipe(
			map((hosts: AddressBookWalletHostModel[]) =>
				hosts.map((host: AddressBookWalletHostModel) => ({
					name: host.wallet_host_name,
					value: host.wallet_host_name,
					wallet_host_id: host.wallet_host_id
				}))
			)
		);
	}
}
